import React from 'react'
import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import {PolicyFamilyTree, FamilyItem} from './PolicyFamilyTree'

interface Props {
  isOpen: boolean
  onClose: () => void
  items: FamilyItem[]
  household: FamilyItem[]
  currentPk: number
}

export const ModalPolicyFamily: React.FC<Props> = ({isOpen, onClose, items, household, currentPk}) => {
  const navigate = useNavigate()

  const handleNavigate = (pk: number) => {
    onClose()
    navigate(`/one-policy/${pk}`)
  }

  return (
    <Modal show={isOpen} onHide={onClose} size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>Related Policies</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {items.length > 1 && (
          <>
            <p className='fw-bold mb-1'>
              Duplication chain
              <span className='text-muted fw-normal ms-2' style={{fontSize: '0.85rem'}}>
                ({items.length} {items.length === 1 ? 'policy' : 'policies'})
              </span>
            </p>
            <p className='text-muted mb-2' style={{fontSize: '0.8rem'}}>
              Policies linked by duplication. Click any to navigate.
            </p>
            <PolicyFamilyTree items={items} currentPk={currentPk} onNavigate={handleNavigate} />
          </>
        )}

        {household.length > 0 && (
          <>
            <hr className='my-4' />
            <p className='fw-bold mb-1'>
              Household / Contact network
              <span className='text-muted fw-normal ms-2' style={{fontSize: '0.85rem'}}>
                ({household.length} {household.length === 1 ? 'policy' : 'policies'})
              </span>
            </p>
            <p className='text-muted mb-2' style={{fontSize: '0.8rem'}}>
              Other policies sharing a contact with this client.
            </p>
            <PolicyFamilyTree
              items={household}
              currentPk={-1}
              onNavigate={handleNavigate}
            />
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
